// @ts-nocheck
import humanizeString from 'humanize-string'
import isEmpty from 'lodash/isEmpty'
import React, { useMemo } from 'react'

import { mainColors } from '@avantstay/backoffice-core'
import { IconCheck } from '@avantstay/backoffice-vectors'

import RadioField from '@new/__ui/RadioField'

import { jsonParseCustomFieldValue } from '@utils/customFields'

import {
  CustomFieldProps,
  CustomFieldTypeReturn,
  IInputProps,
  IMountComponentProps,
} from '../_types'
import { customFieldsTooltipContentWriteMode } from '../constants'
import { stringifyValue } from '../CustomField.utils'
import * as S from './types.styles'

function ComponentReadMode({ customField: { value } }: IMountComponentProps) {
  return (
    <S.Option>
      <IconCheck fill={mainColors.neutralExtremelyDark} />
      {typeof value === 'string' && !!value ? humanizeString(JSON.parse(value) || '') : ''}
    </S.Option>
  )
}

function ComponentWriteMode({
  customField,
  inputProps,
  isReadOnly,
  error,
  disabled,
}: IMountComponentProps) {
  const formattedSelectOptions = useMemo(() => {
    if (customField.shouldRenderSingleOptionAsSelect) {
      return customField.options.map(option => ({
        ...option,
        label: option.title,
      }))
    }

    return []
  }, [customField.options])

  if (isReadOnly) return <ComponentReadMode customField={customField} />

  if (customField.shouldRenderSingleOptionAsSelect) {
    return (
      <S.SelectFieldStyled
        {...inputProps}
        options={formattedSelectOptions}
        placeholder="Select..."
        onChange={(option: OptionProps) =>
          inputProps.onChange({
            target: {
              value: String(option.value),
            },
          })
        }
        value={formattedSelectOptions.find(option => option.value === inputProps?.value)}
      />
    )
  }

  return (
    <RadioField.Group
      {...(inputProps as IInputProps)}
      value={inputProps?.value}
      label={customField.id}
      options={customField.options as unknown as any}
      error={error}
      customTooltipContent={customFieldsTooltipContentWriteMode[customField.name]}
      disabled={disabled}
    />
  )
}

const parseValueToShow = (customField: CustomFieldProps) => {
  const value = jsonParseCustomFieldValue(customField)

  return isEmpty(value) ? null : value
}

const parseValueToSave = (customField: CustomFieldProps) => {
  return stringifyValue(customField.value)
}

export default {
  read: { Component: ComponentReadMode },
  write: { Component: ComponentWriteMode },
  parseValueToShow,
  parseValueToSave,
} as CustomFieldTypeReturn
